import * as React from 'react';
import MobilePreviewExample from '../../../examples/MobilePreviewExample';

export default function MobilePreviewPage() {
  return <MobilePreviewExample />;
}
